import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const path =
  'M6.22.095c-.11.052-.258.156-.328.23-.216.227-.264.396-.284.984l-.017.528-1.926.012c-2.163.012-2.08.001-2.39.321C.977 2.477 1 1.639 1 12s-.023 9.523.275 9.83c.31.32.227.309 2.39.321l1.926.012.017.528c.019.614.08.8.339 1.033.333.3-.145.279 6.193.267l5.68-.011.164-.088c.19-.102.403-.33.481-.518.037-.089.055-.304.055-.671v-.54l1.95-.012c1.908-.011 1.953-.013 2.111-.097.204-.109.364-.269.473-.473l.086-.161V2.58l-.086-.161a1.135 1.135 0 0 0-.473-.473c-.158-.084-.203-.086-2.111-.097l-1.95-.012v-.54c0-.367-.018-.582-.055-.671a1.21 1.21 0 0 0-.481-.518L17.82.02l-5.7-.01L6.42 0l-.2.095M17.04 12.02v10.5H7.12v-21h9.92v10.5M5.6 4.92v1.56h-.92V12h.92v8.64H2.52V3.36H5.6v1.56M21.64 12v8.64h-3.12V12h.96V6.483l-.47-.012-.47-.011-.01-1.55-.011-1.55h3.121V12m-11.4-4.62v2.78h3.68V4.6h-3.68v2.78';

const DevicesIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d={path} />
  </SvgIcon>
);

export default DevicesIcon;
